'use strict';

var React = require('react');

const NavigationContext = /*#__PURE__*/React.createContext({
  location: ''
});

exports.NavigationContext = NavigationContext;
